// extracted by mini-css-extract-plugin
module.exports = {"root":"Overlay_root__X9Ch3","open":"Overlay_open__lwb7g"};